<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->

	<!-- <label>Code:</label>
    <input style="min-width: 200px;" [disabled]="Processing == true" class="form-control" type="text" [(ngModel)]="ActivationCodeShort" placeholder="10 Character Description/Code"> -->

	<label># of Activations Left:</label>
	<label class="InfoText">{{ NewAvailableCount }}</label>

	<label>Total Purchased:</label>
	<label class="InfoText">{{ NewTotalCount }}</label>

	<label>{{ AddSubText }}</label>
	<input class="form-control" type="number" [min]="MinChange" [(ngModel)]="ChangeAmount" (ngModelChange)="onChangeAmountChange($event)" />

	<label>Issue Date:</label>
	<label class="InfoText">{{ IssueDateDesc }}</label>
	<!-- <p-calendar [disabled]="Processing == true" showIcon=true showButtonBar="true" [(ngModel)]="IssueDate" name="IssueDate"></p-calendar> -->

	<label>Expires:</label>
	<input [disabled]="Processing == true" class="form-control CHK" type="checkbox" [(ngModel)]="Expires" (ngModelChange)="onExpiresChange($event)" />

	<label *ngIf="Expires == true">Expire Date:</label>
	<p-calendar
		*ngIf="Expires == true"
		[disabled]="Processing == true"
		showIcon="true"
		showButtonBar="true"
		[(ngModel)]="ExpireDate"
		name="ExpireDate"
		(onShow)="ExpireGrowCell($event)"
		(onClose)="ExpireShrinkCell($event)"
	></p-calendar>
</div>

<div class="DebugBorder">
	<div style="text-align: center">
		<label>Debugging Custom QR Codes</label>
	</div>

	<!--QR Code-->
	<div *ngIf="DebugPhotoData">
		<div style="text-align: center; margin-top: 5px">
			<div class="IMGClass">
				<img class="IMGSize" [src]="DebugPhotoData" />
			</div>
		</div>
	</div>

	<div class="DebugGrid" style="margin-top: 5px">
		<label>Activation Code:</label>
		<label class="InfoText">{{ ActivationCode }}</label>

		<label>Text to Encrypt:</label>
		<label class="InfoText">{{ ToEncrypt }}</label>

		<label>Encrypted Text:</label>
		<label class="InfoText" style="max-width: 280px; word-break: break-all">{{ EncryptedText }}</label>

		<label>URL:</label>
		<input
			style="min-width: 280px"
			[disabled]="Processing == true"
			class="form-control"
			placeholder="IP for your debug environment ex. 10.1.100.116"
			[(ngModel)]="DebugURL"
		/>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button class="btn btn-info" (click)="onPreview()">Preview</button>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
